import axios from 'axios';
import store from '@/store';
import CryptoJS from 'crypto-js';
import browserStorageService from '@/services/browserStorageService';

export default {
  async login({ tenant, username, password, token = '' }) {
    let enc = encrypt(password);
    this.storeEncryptedPw(enc);

    return await axios.get('/users/login', {
      params: { tenant, username, enc },
      headers: {
        'app-token': token,
        'azure-id-token': browserStorageService.getAzureIdToken(),
        'azure-access-token': browserStorageService.getAzureAccessToken(),
      },
    });
  },
  getCockpitAccessToken() {
    console.log('getCockpitAccessToken');
    let enc = this.getEncryptPw();
    return axios.get('/users/cockpit-access-token', { params: { enc } });
  },
  storeEncryptedPw(enc) {
    localStorage.setItem('usec', encrypt(enc));
  },
  getEncryptPw() {
    return decrypt(localStorage.getItem('usec') || '');
  },
  async checkAccess() {
    const isConnected = navigator.onLine;
    if (isConnected) {
      try {
        let response = await axios.post(`/users/check-access`, {});
        let responseData = response.data;
        if (typeof responseData.access === 'boolean' && responseData.access === false) {
          store.dispatch('profile/logout');
          if ('Notification' in window && Notification.permission == 'granted') {
            let notification = new Notification('Zugriff eingeschränkt', {
              body: 'Sie haben keinen Zugriff auf die WebApp und wurden automatisch abgemeldet.',
            });
            setTimeout(function () {
              notification.close();
            }, 20000);
          }
        }
      } catch (err) {
        console.warn('failed to check access. Ignoring');
      }
    }
  },
};

/**
 * Encrypt but ensure result is always the same. Required for PWA to be able to cache request
 * @param {*} password
 * @returns
 */
function encrypt(password) {
  const key = '55a51621a6648525';
  const keyutf = CryptoJS.enc.Utf8.parse(key);
  const iv = CryptoJS.enc.Base64.parse(key);

  const enc = CryptoJS.AES.encrypt(password, keyutf, { iv: iv });
  const encStr = enc.toString();

  return encStr;
}

function decrypt(encryptedString) {
  const key = '55a51621a6648525';
  const keyutf = CryptoJS.enc.Utf8.parse(key);
  const iv = CryptoJS.enc.Base64.parse(key);

  const dec = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Base64.parse(encryptedString) }, keyutf, {
    iv: iv,
  });
  const decStr = CryptoJS.enc.Utf8.stringify(dec);
  return decStr;
}
